"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M10.0291 10.0278c.5858-.5858.5858-1.5355 0-2.1213-.5857-.5858-1.5355-.5858-2.1213 0-.5858.5857-.5858 1.5355 0 2.1213.5858.5858 1.5356.5858 2.1213 0z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.2037 4.2037-1.2535 7.9389 10.3866 10.3866 9.1924-9.1924L12.1426 2.9502 4.2037 4.2037zm9.1331 15.4971-8.2522-8.2523.8678-5.4961 5.4961-.8678 8.2523 8.2522-6.364 6.364z"
  })];
};

exports.default = _default;